// extracted by mini-css-extract-plugin
export default {"l_MainTitle_main":"MainTitle_l_MainTitle_main__Al1FE"};